/* unplugin-vue-components disabled */import { render } from "./CIcon.vue?vue&type=template&id=50744e6f&ts=true"
import script from "./CIcon.vue?vue&type=script&lang=ts"
export * from "./CIcon.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__